module.exports = __webpack_public_path__ + "img/apple_white.90dbc25c.svg";